import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Silent session refresh: the short-lived access token (1h) is renewed from the
// 7-day refresh cookie automatically, so admin/customer sessions don't suddenly
// start failing with 401s mid-work.
let refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const isAuthCall = original?.url?.includes("/auth/");
    if (error.response?.status === 401 && !original?._retried && !isAuthCall) {
      original._retried = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
        await refreshing;
        return api(original);
      } catch {
        // If refresh fails on an admin page, reload the current admin URL
        // directly — AdminGate handles sign-in inline with zero redirects.
        if (window.location.pathname.startsWith("/admin")) {
          window.location.reload();
        }
      }
    }
    return Promise.reject(error);
  }
);

export const LOGO = "/assets/btm-logo.png";

export const formatR = (n) =>
  new Intl.NumberFormat("en-ZA", { style: "currency", currency: "ZAR" }).format(Number(n) || 0);

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

export const CATEGORY_IMAGES = {
  stationery:
    "https://images.unsplash.com/photo-1766961557611-0d0ebe2311c2?crop=entropy&cs=srgb&fm=jpg&q=85",
  textbooks:
    "/assets/textbooks-btm.jpg",
  "religious-books":
    "https://images.unsplash.com/photo-1704151893532-b5c829ac1d1f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHw0fHxob2x5JTIwYmlibGUlMjBoYXJkY292ZXJ8ZW58MHx8fHwxNzkxNTYzODY4fDA&ixlib=rb-4.1.0&q=85",
  "art-craft":
    "https://images.unsplash.com/photo-1698340311456-77454d0abdc7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxjaGlsZHJlbiUyMHNjaG9vbCUyMHBhaW50cyUyMGFuZCUyMGJydXNoZXN8ZW58MHx8fHwxNzkxNTY0MzA3fDA&ixlib=rb-4.1.0&q=85",
  "educational-toys":
    "https://images.unsplash.com/photo-1558907353-ceb54f3882ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHx3b29kZW4lMjBhbHBoYWJldCUyMGJsb2NrcyUyMGVkdWNhdGlvbmFsJTIwdG95c3xlbnwwfHx8fDE3OTE1NjQzMDd8MA&ixlib=rb-4.1.0&q=85",
  "corporate-gifts":
    "https://images.unsplash.com/photo-1719622144233-7f4a09ee199b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBnaWZ0JTIwc2V0fGVufDB8fHx8MTc5MTU2MjM3N3ww&ixlib=rb-4.1.0&q=85",
};

export const CATEGORY_NAMES = {
  stationery: "Stationery",
  textbooks: "Textbooks",
  "religious-books": "Religious Books",
  "art-craft": "Art & Craft",
  "educational-toys": "Educational Toys",
  "corporate-gifts": "Corporate Gifts",
};

export const ORDER_STATUS_LABELS = {
  pending_payment: "Pending payment",
  processing: "Processing",
  preparing: "Being prepared",
  ready_for_collection: "Ready for collection",
  dispatched: "Dispatched",
  failed_delivery: "Failed delivery",
  completed: "Completed",
  cancelled: "Cancelled",
  refunded: "Refunded",
};
